/**
 * POST DEPARTMENT
 */
import * as _ from 'lodash-es';
import { Dispatch } from 'redux';

import {
  ACTION_POST_DEPARTMENT,
  ACTION_POST_DEPARTMENT_SUCCESS,
  ACTION_POST_DEPARTMENT_FAILURE,
  ACTION_RESET_DEPARTMENT_SUCCESS,
  API_CALL,
} from '../../configs/ActionTypes';
import { enqueueSnackbarHandler } from '../Status';

export function add(name: string, organizationId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/department`,
        method: 'post',
        data: JSON.stringify({ name: name }),
        success: (response: object) => {
          dispatch(requestSuccess(response));
          enqueueSnackbarHandler(
            dispatch,
            { addDepartmentSuccess: true },
            'success',
          );
        },
        fail: (error: any) => {
          _.get(error.payload, 'userPermissionError', false)
            ? enqueueSnackbarHandler(dispatch, error.payload, 'error')
            : enqueueSnackbarHandler(
                dispatch,
                { addDepartmentFailed: true },
                'error',
              );
          dispatch(requestFailed());
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_POST_DEPARTMENT,
    payload: null,
  };
}

export function resetAddDepartment() {
  return (dispatch: Dispatch, getState: Function) => {
    // Dispatch the api call request.
    dispatch({
      type: ACTION_RESET_DEPARTMENT_SUCCESS,
      payload: null,
    });
  };
}

export function requestSuccess(responeJSON: object) {
  return {
    type: ACTION_POST_DEPARTMENT_SUCCESS,
    payload: responeJSON,
  };
}

export function requestFailed() {
  return {
    type: ACTION_POST_DEPARTMENT_FAILURE,
    payload: null,
  };
}
